import { ReactElement, ChangeEvent, useMemo, useCallback } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useFormikContext } from 'formik';

import {
  SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME,
  getScheduleRouteBaseFormInititalValues,
} from '../../../utils/scheduleRouteForm';

import { AssistantGenerateRoutesDialogScheduleRouteCardProps } from '../types';

const AssistantGenerateRoutesDialogScheduleRouteCardTitle = ({
  onEnabled,
}: Pick<
  AssistantGenerateRoutesDialogScheduleRouteCardProps,
  'onEnabled'
>): ReactElement => {
  const { values, setFieldValue, validateForm, getFieldProps } =
    useFormikContext<
      ReturnType<typeof getScheduleRouteBaseFormInititalValues>
    >();

  const isEnabled = useMemo(
    () => values[SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED],
    [values],
  );

  const handleChangeEnabled = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target;

      setFieldValue(
        SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED,
        checked,
        false,
      );

      onEnabled(checked);

      await validateForm();
    },
    [onEnabled, setFieldValue, validateForm],
  );

  return (
    <FormControlLabel
      label="PROGRAMAR RUTA"
      componentsProps={{
        typography: {
          variant: 'subtitle2',
          fontWeight: 'bold',
        },
      }}
      control={
        <Switch
          {...getFieldProps(
            SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED,
          )}
          checked={isEnabled}
          onChange={handleChangeEnabled}
          size="small"
        />
      }
      sx={{ marginLeft: -0.5 }}
    />
  );
};

export default AssistantGenerateRoutesDialogScheduleRouteCardTitle;
